import tooltip from "../../../Charts/Tooltip/Tooltip"
import {
  CHART_TYPE,
  CHART_COMPONENT,
  chartFormatter,
} from "../../../Charts/chart-util"

import { isNonEmptyArray } from "web/services/helpers"

function Chart({ chartKind, data, colour, yAxisLabel }) {
  const hasData = isNonEmptyArray(data) && !data.every((el) => el.value === 0)

  const firstItemInData = hasData && data[0]
  const { unit, kind, format } = firstItemInData || {}

  const formatter = (data) => chartFormatter(data, kind, unit, format)

  const ViewComponent = CHART_COMPONENT[chartKind || CHART_TYPE.PIE]

  return (
    <>
      {!hasData && (
        <div className="grid place-items-center items-center text-xs italic text-neutral-6">
          No Data To Chart
        </div>
      )}
      {hasData && (
        /* need min-w-0 below to solve recharts bug */
        <div className="h-full min-h-0 min-w-0 text-xs">
          <ViewComponent
            data={hasData ? data : []}
            tooltipContent={tooltip({ formatter, chartKind })}
            formatter={formatter}
            colour={colour}
            yAxisLabel={yAxisLabel}
          />
        </div>
      )}
    </>
  )
}

export default function ChartWrapper({ kind, data, yAxisLabel }) {
  return (
    <div className="chart grid h-full overflow-hidden rounded-md bg-white p-2">
      <Chart chartKind={kind} data={data} yAxisLabel={yAxisLabel} />
    </div>
  )
}
